/**
 * @author HungNS
 */
const GET_SYSTEM_CACHE = "getSystemCache";
const SET_SYSTEM_CACHE = "setSystemCache";
const GET_AMS_CUSTOMER_INFO = "getAmsCustomerInfo";
const SET_AMS_CUSTOMER_INFO = "setAmsCustomerInfo";
const INIT_FORCE_NEWS = "initForceNews";
const SET_REMAIN_FORCE_NEWS_LIST = "setRemainForceNewsList";


export {
    INIT_FORCE_NEWS,
    GET_SYSTEM_CACHE,
    SET_SYSTEM_CACHE,
    GET_AMS_CUSTOMER_INFO,
    SET_AMS_CUSTOMER_INFO,
    SET_REMAIN_FORCE_NEWS_LIST
};
